export default "__VITE_ASSET__hSBX1Cy6__"